export const CONNECTED = 1;
export const DISCONNECTED = 2;



// WEBPACK FOOTER //
// ./js/constants/ConnectionStatus.js